var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "PopUp",
    {
      attrs: {
        title: "Ausschluss entfernen",
        "ok-text": "Löschen",
        "ok-disabled": _vm.removing,
        "ok-loading": _vm.removing,
        closable: !_vm.removing
      },
      on: {
        ok: _vm.remove,
        hidden: function($event) {
          return _vm.$emit("hidden")
        }
      }
    },
    [
      _vm._v("\n\tSoll der Ausschluss für "),
      _c("b", [_vm._v(_vm._s(_vm.exclusion.jobProfile.info))]),
      _vm._v(" wirklich gelöscht werden?\n")
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }